 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		8: 0
 	};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		8: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"commons","1":"de7ae27c3942a3939856c8cb6f2635b3f18ee7de","2":"8c012a2acc8e5881da26e0eb7ebda0f76e783076","3":"4fa6f3ce4e8ccd5325cead933c4376ffd55d0987","4":"4d8f7713b91f7d35f217f7a1d1e898a2ff384616","5":"fb791a8693bd674de920449d9ea649da67b935c9","6":"7695358b5badde6b8a5b7b4830241c92e70c32f0","7":"framework","10":"component---gatsby-theme-husky-src-templates-404-404-tsx","11":"component---gatsby-theme-husky-src-templates-article-about-strepsils-page-index-tsx","12":"component---gatsby-theme-husky-src-templates-article-landing-page-article-landing-page-tsx","13":"component---gatsby-theme-husky-src-templates-article-page-article-page-tsx","14":"component---gatsby-theme-husky-src-templates-article-symptoms-page-index-tsx","15":"component---gatsby-theme-husky-src-templates-contact-us-page-contact-us-page-tsx","16":"component---gatsby-theme-husky-src-templates-home-page-home-page-tsx","17":"component---gatsby-theme-husky-src-templates-lds-page-lds-page-tsx","18":"component---gatsby-theme-husky-src-templates-product-page-product-page-tsx","19":"component---gatsby-theme-husky-src-templates-product-quiz-page-product-quiz-page-tsx","20":"component---gatsby-theme-husky-src-templates-products-list-page-products-list-page-tsx","21":"component---gatsby-theme-husky-src-templates-search-result-page-search-result-page-tsx","22":"component---gatsby-theme-husky-src-templates-site-map-page-site-map-page-tsx"}[chunkId]||chunkId) + "-" + {"0":"c7da2a1b3de701304b56","1":"1820a22943cbfb2ed986","2":"ac24efd6075b928fabdf","3":"3b9020fa1de0a6e053b4","4":"3a0b2394c57e78378025","5":"f3225833650ed21d29c1","6":"0440cda8d455911d3680","7":"e00645fcd4677a45b102","10":"99144df9f548c607fa55","11":"23bc53d80c3126ddd507","12":"20fd5f4aed090b775cd6","13":"ab42bc0ab784dcf7f248","14":"56bbf8bfb1f9a866b63c","15":"27cb3ca818589e295a2d","16":"90fcd12110c7d83b85f6","17":"d5647638706edf602ce3","18":"991c145ed3f4262177d5","19":"5bda18dca77094dbfa89","20":"b98f58973704dbad5a0a","21":"08bac15c98c4c6e6d5e0","22":"02293749aa08c200944a","25":"41541c7f7100a837e0ce","26":"d574ead2ccd1e65dbcba","27":"d38499bb0096e0628b20","28":"85c6984292bf4ce0536e","29":"affca07822d98f25a798","30":"9303db12e0db525487ca"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"0":1,"10":1,"11":1,"12":1,"13":1,"14":1,"15":1,"16":1,"17":1,"18":1,"19":1,"20":1,"21":1,"22":1,"25":1,"26":1,"27":1,"28":1,"29":1,"30":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"0":"commons","1":"de7ae27c3942a3939856c8cb6f2635b3f18ee7de","2":"8c012a2acc8e5881da26e0eb7ebda0f76e783076","3":"4fa6f3ce4e8ccd5325cead933c4376ffd55d0987","4":"4d8f7713b91f7d35f217f7a1d1e898a2ff384616","5":"fb791a8693bd674de920449d9ea649da67b935c9","6":"7695358b5badde6b8a5b7b4830241c92e70c32f0","7":"framework","10":"component---gatsby-theme-husky-src-templates-404-404-tsx","11":"component---gatsby-theme-husky-src-templates-article-about-strepsils-page-index-tsx","12":"component---gatsby-theme-husky-src-templates-article-landing-page-article-landing-page-tsx","13":"component---gatsby-theme-husky-src-templates-article-page-article-page-tsx","14":"component---gatsby-theme-husky-src-templates-article-symptoms-page-index-tsx","15":"component---gatsby-theme-husky-src-templates-contact-us-page-contact-us-page-tsx","16":"component---gatsby-theme-husky-src-templates-home-page-home-page-tsx","17":"component---gatsby-theme-husky-src-templates-lds-page-lds-page-tsx","18":"component---gatsby-theme-husky-src-templates-product-page-product-page-tsx","19":"component---gatsby-theme-husky-src-templates-product-quiz-page-product-quiz-page-tsx","20":"component---gatsby-theme-husky-src-templates-products-list-page-products-list-page-tsx","21":"component---gatsby-theme-husky-src-templates-search-result-page-search-result-page-tsx","22":"component---gatsby-theme-husky-src-templates-site-map-page-site-map-page-tsx"}[chunkId]||chunkId) + "." + {"0":"935bde85e3d5d5219de1","1":"31d6cfe0d16ae931b73c","2":"31d6cfe0d16ae931b73c","3":"31d6cfe0d16ae931b73c","4":"31d6cfe0d16ae931b73c","5":"31d6cfe0d16ae931b73c","6":"31d6cfe0d16ae931b73c","7":"31d6cfe0d16ae931b73c","10":"eb6de9d72030a786dd73","11":"286696f65fe1add836df","12":"34ccfe79510883a47371","13":"f1bffa7ae7b5107cd58a","14":"d02fc7ac5181c5e6a871","15":"058cdc5b2d3806bbe698","16":"17e1d6ed1fb6d873ee30","17":"8339e0795ca606108422","18":"790e4596b508d970ab80","19":"cb042ef2e7290194837a","20":"84110558335942bace2f","21":"eb98b0baa6afd15ec0ca","22":"b7560e8ce7a20d872ce2","25":"71f642986343521409c3","26":"a9c5c01c1d383b3d0bd3","27":"7005f88c9b1f1b5c216d","28":"f43d9df51d04124d05d9","29":"57ccbd6b99d49d4c48e4","30":"b87f36b2210c5126b4f1"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["__LOADABLE_LOADED_CHUNKS__"] = window["__LOADABLE_LOADED_CHUNKS__"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
